/**
 * Archivo que contiene los endpoints necesarios para la visualizacion del backlog
 * @author Oscar Rosero <oscr.rosero@repremundo.com.co>
 * @since 2024-12-27
 */
import { apiSlice } from "../../apiSlice";

const headers = { Modulecima: "Modimpxx" };

export const CreadoxxApiSlice = apiSlice.injectEndpoints({
  overrideExisting: true,
  endpoints: (builder) => ({
    getIndicators: builder.query({
      query: (parameters) => ({
        url: `/Modimpxx/Backlogx/getIndicators`,
        method: "GET",
        params: { ...parameters },
        headers
      }),
    }),
    updateDo: builder.mutation({
      query: (parameters) => ({
        url: `/Modimpxx/Backlogx/updateDo/${parameters.DOCNROXX}`,
        method: "PUT",
        body: parameters,
        headers
      }),
      invalidatesTags: ["Create"],
    }),
    getSpecificObjetives: builder.query({
      query: (parameters) => ({
        url: `/Modimpxx/Backlogx/getSpecificObjetivesDo`,
        method: "GET",
        params: { ...parameters },
        headers
      }),
      providesTags: ["KeyResults"],
    }),
    getCoordinatorDo: builder.query({
      query: (parameters) => ({
        url: `/Modimpxx/Backlogx/getCoordinatorDo`,
        method: "GET",
        params: { ...parameters },
        headers
      }),
    }),
    getCordinatorByClient: builder.query({
      query: (CLIIDXXX) => ({
        url: `/Modimpxx/Backlogx/getCordinatorByClient/${CLIIDXXX}`,
        method: "GET",
        headers
      }),
    }),
    getMeansTransportModimpxx: builder.query({
      query: () => ({
        url: `/Modimpxx/Backlogx/getMeansTransport`,
        method: "GET",
        headers
      }),
    }),
    getJurisdictionByClient: builder.query({
      query: (parameters) => ({
        url: `/Modimpxx/Backlogx/getJurisdictionByClient`,
        method: "GET",
        params: { ...parameters },
        headers
      }),
    }),
    getKpiByClient: builder.query({
      query: (parameters) => ({
        url: `/Modimpxx/Backlogx/getKpiByClient`,
        method: "GET",
        params: { ...parameters },
        headers
      }),
    }),
    getSucursales: builder.query({
      query: () => ({
        url: `/Modimpxx/Backlogx/getSucursales`,
        method: "GET",
        headers
      }),
    }),
    getKpiByOperationImpo: builder.query({
      query: ({ DOCNROXX, MTRIDXXX, SUCIDXXX }) => ({
        url: `/Modimpxx/Backlogx/kpiByOperation/${DOCNROXX}/${MTRIDXXX}/${SUCIDXXX}`,
        method: "GET",
        headers
      }),
    }),
  }),
});

export const {
  useGetIndicatorsQuery,
  useUpdateDoMutation,
  useGetSpecificObjetivesQuery,
  useLazyGetCoordinatorDoQuery,
  useGetCordinatorByClientQuery,
  useGetMeansTransportModimpxxQuery,
  useGetJurisdictionByClientQuery,
  useLazyGetKpiByClientQuery,
  useGetSucursalesQuery,
  useLazyGetKpiByOperationImpoQuery,
} = CreadoxxApiSlice;
